import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { StatusTag } from '../enums/status-tag.enum';

@Component({
  selector: 'sg-status-tag',
  templateUrl: './sg-status-tag.component.html',
  styleUrls: ['./sg-status-tag.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SgStatusTagComponent {
  @Input() status: StatusTag | keyof typeof StatusTag;
  @Input() text: string;
  @Input() size: 'small' | 'default' = 'default';
  @Input() withDot = false;
  @Input() withBorder = false;
  @Input() inverted = false;
}
